<template>
  <div :class="checked?'questionDivPitchOn':'questionDiv'" @click="iQuestionId != 0 && checkOneChange()">
    <a href="javascript:" @click="showSlide()">
      <img
        onload="if(this.width>this.height){this.width=100;}else{this.height=100}"
        class="item-img"
        :src="this.thumbnail"
        alt=""
      />
    </a>
    <p>
      <span>({{ this.courseDataName }})</span>
    </p>
    <!-- <ul class="questionInfo"> -->
    <p class="question" v-for="(item, index) in questionStem" :key="index">
      <span>{{ index + 1 + '.' + item }}</span>
    </p>
    <!-- </ul> -->
    <!-- <div class="answerDiv">
        <span>{{this.$t('translateText.aq.hd')}}：</span>{{answer}}
    </div> -->
    <div class="questionScoreDiv">
      <p class="correct" v-show="correctAnswerShow">
        {{ $t('translateText.common.zqda') }} ：{{ correctAnswer }}
      </p>
      <span v-show="ScoreShow">{{ $t('translateText.common.btdf') }} ：</span>
      <a-input
        v-if="this.$route.path == '/courseContent/Review'"
        type="text"
        v-model="question.iScore"
        v-show="ScoreShow"
      />
      <a-input
        v-else
        type="text"
        @blur="updatescore"
        v-model="questionScore"
        v-show="ScoreShow"
        onkeyup="value=value.replace(/[^\d]/g,'')"
        @click.stop
      />
      <span v-show="ScoreShow">{{ $t('translateText.fbzy.f') }}</span>
      <span
        v-if="this.$route.path == '/courseContent/Review'"
        v-show="ScoreShow"
        style="margin-left:10px; color: #F86B4F;"
        >({{ this.questionAnswerScore }}{{ $t('translateText.fbzy.f') }})</span
      >
    </div>
    <!-- <div v-if="iQuestionId != 0" class="checkboxDiv">
      <a-checkbox :checked="checked" @change="checkOneChange"></a-checkbox>
    </div> -->
    <div style="line-height: 2">
      <span v-show="false"
        ><a-icon
          type="star"
          v-if="showcollect == false"
          theme="twoTone"
          two-tone-color="#FF8C00"
          style="cursor: pointer"
          @click="collecting"
        />
        <a-icon
          type="star"
          v-if="showcollect"
          style="cursor: pointer"
          @click="collecting"
        />
        收藏题目</span
      >
      <span style="word-wrap:break-word">{{ $t('translateText.common.jx') }} ：{{ questionanalysis }}</span>
    </div>
    <div class="borderline"></div>
  </div>
</template>
<script>
export default {
  props: {
    questionAnswerInfo: {
      type: Object,
      default: null,
    },
    questionInfo: {
      type: Object,
      default: null,
    },
    correctAnswerShow: {
      type: Boolean,
      default: true,
    },
    ScoreShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      iExamQuestionId: '', //试卷选题id
      checked: false,
      selectedtopic: [], //选中的题目
      info: {},
      questionStem: [],
      correctAnswer: null,
      questionScore: 10,
      questionNum: 0,
      answer: null,
      iQuestionId: 0,
      questionanalysis: null,
      showcollect: true,
      thumbnail: '',
      courseDataName: '',
      question: '',
      questiondetails: '', //查看实验题所用的题目详情
      questionAnswerScore: 0,
    }
  },
  mounted() {
    this.getData()

    if (
      this.$route.path != '/courseContent/Review' &&
      this.$route.path != '/StudentWorkInfo'
    ) {
      this.selectedtopic = this.$parent.selectedtopic
      this.selectedtopic.map((item) => {
        if (item.question.iQuestionId == this.iQuestionId) {
          this.checked = true
          this.questionScore = item.iScore
          this.iExamQuestionId = item.iExamQuestionId
        }
      })
    }
  },
  methods: {
    showSlide() {
      this.$emit('showSlide', this.questiondetails)
    },
    updatescore() {
      if (this.iExamQuestionId == '') {
        this.info = {
          question: this.question,
          iScore: this.questionScore,
        }
        this.$emit('update', this.info)
      } else {
        this.info = {
          iExamQuestionId: this.iExamQuestionId,
          question: this.question,
          iScore: this.questionScore,
        }
        this.$emit('update', this.info)
      }
    },
    collecting() {
      this.showcollect = !this.showcollect
    },
    checkOneChange() {
      this.checked = !this.checked
      this.info = {
        question: this.question,
        iScore: this.questionScore,
      }
      this.$emit('allCheck', this.info)
    },
    checkQuestion(ExaminationQuestionList, questionComp) {
      for (var i = 0; i < ExaminationQuestionList.length; i++) {
        if (
          ExaminationQuestionList[i].question.iQuestionId == this.iQuestionId
        ) {
          questionComp.$el.querySelectorAll(
            '.checkboxDiv'
          )[0].firstChild.firstChild.className =
            'ant-checkbox ant-checkbox-checked'
          questionComp.$el.querySelectorAll(
            '.checkboxDiv'
          )[0].firstChild.firstChild.firstChild.checked = true
          this.questionScore = ExaminationQuestionList[i].iScore
          break
        }
      }
    },
    getData() {
      if (this.questionAnswerInfo != null) {
        this.question = this.questionAnswerInfo
        this.questiondetails = this.questionAnswerInfo.examinationQuestion.question
        this.iQuestionAnswerId = this.questionAnswerInfo.iQuestionAnswerId
        this.questionAnswerScore = this.questionAnswerInfo.examinationQuestion.iScore
        this.correctAnswer = this.questionAnswerInfo.examinationQuestion.question.strStandardAnswer
        this.questionScore = this.questionAnswerInfo.iScore
        this.questionStem = [
          JSON.parse(
            JSON.parse(
              this.questionAnswerInfo.examinationQuestion.question
                .strQuestionInfo
            ).question
          ).strDescribe,
        ]
        this.questionNum = this.questionAnswerInfo.iQuestionNum
        this.answer = this.questionAnswerInfo.strAnswer
        this.questionanalysis = this.questionAnswerInfo.examinationQuestion.question.strQuestionParsing
        this.thumbnail = this.questionAnswerInfo.examinationQuestion.question.courseData.strThumbnail
        this.courseDataName = this.questionAnswerInfo.examinationQuestion.question.courseData.strCourseDataName
      } else if (this.questionInfo != null) {
        this.question = this.questionInfo
        this.questionStem = []
        this.questiondetails = this.questionInfo
        this.answer = this.questionInfo.strStandardAnswer
        this.iQuestionId = this.questionInfo.iQuestionId
        this.questionanalysis = this.questionInfo.strQuestionParsing
        this.thumbnail = this.questionInfo.courseData.strThumbnail
        this.courseDataName = this.questionInfo.courseData.strCourseDataName
        if (this.questionInfo.ddQuestionType.iNumber == 6) {
          this.questionStem = JSON.parse(
            this.questionInfo.strQuestionInfo
          ).question
        } else if (this.questionInfo.ddQuestionType.iNumber == 7) {
          let questionarr = JSON.parse(
            JSON.parse(this.questionInfo.strQuestionInfo).question
          )
          questionarr.map((item) => {
            this.questionStem.push(item.strDescribe)
          })
        }
        //.map((item,index)=>{this.questionStem += index+1 + "." +item +"。"})
      }
    },
  },
  components: {},
  computed: {},
  watch: {
    'question.iScore'() {
      if (this.question.iScore == '') {
        this.question.iScore = 0
      }
      if (this.questionAnswerScore < this.question.iScore) {
        this.question.iScore = 0
        return this.$message.error(this.$t('translateText.common.cgfs'))
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
.borderline
    margin-top:1.5%;
    margin-left:-1%;
    margin-right:1%;
    border-bottom:1px solid rgba(230, 230, 230, 1);
.questionDiv{
  width: 100%;
  position: relative;
}
.questionDivPitchOn{
  width: 100%;
  position: relative;
  background: url('../../assets/imgs/duihao1.png');
  background-repeat: no-repeat;
  background-position-x: right;
  background-position-y: center;
  background-size: 10%;
}
.questionInfo {
  font-weight: 400;
  color: #515151;
  margin: 10px 0;
  padding-left: 10px;
  border-left: solid 3px #2EADB5;
  font-size: 16px;
}
.answerDiv{
    margin-top: 10px;
    color: #9a9a9a;
    line-height: 25px;
    font-size: 16px;
}
.answerDiv span{
    font-weight: 600;
}
.correct {
  margin-top: 10px;
  line-height: 25px;
  font-weight: 400;
  font-size: 16px;
  color: #F86B4F;
  margin-right: 20px;
}

.questionScoreDiv span {
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #333333;
  marging: 0 10px;
}

.questionScoreDiv input {
  height: 25px;
  width: 60px;
  margin: 0 5px;
  border: 1px solid #888888;
  text-align: center;
  color: #F86B4F;
}
.question{
  font-weight: 400;
  width:80%;
  color: #515151;
  margin: 10px 0;
  padding-left: 10px;
  border-left: solid 3px #2EADB5;
  font-size: 16px;
}
&/deep/ .ant-input{
  border-radius: 5px;
  float: inherit;
}
.checkboxDiv{
    float:left;
    position: absolute;
    top: 45%;
    right: 10%;
}
.checkboxDiv label{
  background-color: #fff;
}
&/deep/.ant-checkbox-inner{
  border: 2px solid #2EADB5;
}
&/deep/.ant-checkbox-input:focus + .ant-checkbox-inner{
  border-color: #2EADB5;
}
&/deep/.ant-checkbox-checked .ant-checkbox-inner{
  background-color: #2EADB5;
  border-color: #2EADB5;
}
</style>
